import React, { FC, useEffect, useState, useMemo, useRef } from 'react'
import {
  fetchData,
  findMenuWithParent,
  getEncodedCookie,
  getEncryptedRoute,
  toasterrormsg,
  useMenuIdPermissions,
} from '../../../../../../../reusable'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import { toAbsoluteUrl } from '../../../../../../../_metronic/helpers'
import { KTIcon } from '../../../../../../../_metronic/helpers'
import { Tr } from '../../../../../../../_metronic/i18n/Tr'
import { useMenuContext } from '../../../../../contexts/MenuContext'

export default function CafeRestaurant() {
  //  hotel list api call
  let t = Tr()

   const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const { menuIdEdit, menuId, menuIdDelete, menuIdAdd } = useMenuIdPermissions()
  const { fullMenu } = useMenuContext()
  const result = findMenuWithParent(fullMenu, '../viewrestaurants/');
  const restaurantMenuId = result?.menu?.menuId

  const [restaurantList, setRestaurantlist] = useState([])
  const [orgRestaurntantList, setOrgRestaurantList] = useState([])

  const [vendorId2, setVendorId] = useState<number | string | null>(null)

  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')

  useEffect(() => {
    const encodedVendorId = sessionStorage.getItem('locationVendorId')
    if (encodedVendorId) {
      try {
        // Decode base64 and convert to number
        const decodedVendorId = atob(encodedVendorId)
        setVendorId(decodedVendorId)
        restaurantListAPIcall(decodedVendorId)
      } catch (error) {
        setVendorId(null)
      }
    }
  }, [])

  const hotelSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setRestaurantlist(orgRestaurntantList)
    } else {
      var tmp: any = orgRestaurntantList.filter((item: any) => {
        return (
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.vendorDetails[0].fullName != null &&
            item.vendorDetails[0].fullName != '' &&
            item.vendorDetails[0].fullName.toLowerCase().includes(text.toLowerCase())) ||
          (item.type != null &&
            item.type != '' &&
            item.type.toLowerCase().includes(text.toLowerCase())) ||
          (item.submitDate != null &&
            item.submitDate != '' &&
            String(item.submitDate).toLowerCase().includes(text.toLowerCase())) ||
          (item.verifiedDate != null &&
            item.verifiedDate != '' &&
            String(item.verifiedDate).toLowerCase().includes(text.toLowerCase())) ||
          (item.businessInfostatus != null &&
            item.businessInfostatus != '' &&
            String(item.businessInfostatus).toLowerCase().includes(text.toLowerCase()))
        )
      })

      setRestaurantlist(tmp)
    }
  }

  const restaurantListAPIcall = async (vendorId2: any = '') => {
    var param = {
      vendorId: vendorId2,
    }
    var res = await fetchData('vendor/public/restaurantList', param)

    if (res.status == '200') {
      var data = res.data
      setRestaurantlist(data)
      setOrgRestaurantList(data)
    } else {
      toasterrormsg(res.message)
    }
  }
  const rejectconfirmation = async (status: any, id: any) => {
    Swal.fire(
      status == '2'
        ? {
          title: t('Are You Sure? You Want to Reject This Restaurannt .'),
          icon: 'warning',
          showCancelButton: true,
          input: 'text',
          inputLabel: t('Reason'),
          confirmButtonText: t('Ok'), // Custom OK button text
          cancelButtonText: t('Cancel'), // Custom Cancel button text
          inputPlaceholder: t('Enter Reject Reason'),
          inputValidator: (value) => {
            // Validate input here
            if (!value) {
              return t('Reject Reason Required!')
            }
            if (value.length > 150) {
              return t('Reject Reason cannot exceed 150 characters!')
            }
          },
        }
        : {
          title: t('Are You Sure? You Want to Approve This Restaurant .'),
          icon: 'warning',
          showCancelButton: true,
        }
    ).then(async (result) => {
      if (result.isConfirmed) {
        const inputValue = result.value
        if (status == '1') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'restaurant',
              adminId: adminId,
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              confirmButtonText: t('Ok'), // Custom OK button text

              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                restaurantListAPIcall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              confirmButtonText: t('Ok'), // Custom OK button text

              icon: 'error',
            })
          }
        } else if (inputValue !== undefined && inputValue.trim() !== '' && status == '2') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'restaurant',
              adminId: adminId,
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              confirmButtonText: t('Ok'), // Custom OK button text

              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                restaurantListAPIcall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              confirmButtonText: t('Ok'), // Custom OK button text

              icon: 'error',
            })
          }
        } else {
          // If input value is not valid, show error message
          Swal.fire({
            title: t('Invalid Input!'),
            text: t('Please enter a valid reason.'),
            icon: 'error',
          })
        }
      }
    })
  }

  //   delete hotel api call
  const confirmdelete = (restaurantId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          restaurantId: restaurantId,
          adminId: adminId,
        }
        var res = await fetchData('vendor/public/deleteRestaurant', param)

        if (res.status == '200') {
          restaurantListAPIcall(vendorId2)
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }


  const column = useMemo(
    () => [
      {
        name: t('Property Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6 d-flex align-items-center justify-content-center'>
              <img
                className='w-50px h-50px me-2'
                src={
                  row.images.length > 0
                    ? row.images[0]['thumbPath']
                    : toAbsoluteUrl('/media/logos/uztripLogo.png')
                }
                alt='images'
              />
              <Link
                to={getEncryptedRoute('../../../restaurantoverview/', { menuId: restaurantMenuId })}

                state={{ restaurantId: row.restaurantId }}
                className='text-dark fw-bold text-hover-primary fs-5'
              >
                <label className=''>{row.en_name}</label>
              </Link>{' '}
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: t('Vendor Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.vendorDetails && row.vendorDetails.length > 0
                ? row.vendorDetails[0].fullName
                : ''}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) =>
          row.vendorDetails && row.vendorDetails.length > 0 ? row.vendorDetails[0].fullName : '',
      },
      {
        name: t('Property Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.type}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.type),
        filter: true,
      },

      {
        name: t('Submitted Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.submitDate || '--'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.submitDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.submitDate ? new Date(rowA.submitDate) : null
          const dateB = rowB.submitDate ? new Date(rowB.submitDate) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
      },
      {
        name: t('Verified Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.verifiedDate || '--'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.verifiedDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.verifiedDate ? new Date(rowA.verifiedDate) : null
          const dateB = rowB.verifiedDate ? new Date(rowB.verifiedDate) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
      },
      {
        name: t('Verification Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              {row.businessInfostatus == 0 ? (
                <span className='badge badge-warning mx-2'>{t('Pending')}</span>
              ) : row.businessInfostatus == 1 ? (
                <span className='badge badge-success mx-2'>{t('Verified')}</span>
              ) : (
                <span className='badge badge-danger mx-2'>{t('Rejected')}</span>
              )}
            </label>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },

      {
        name: t('Approve Reject'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? <div className='pt-4 pb-4'>
              {row.businessInfostatus == 0 ? (
                <>
                  <button
                    className='btn btn-success btn-sm me-3 mb-2 '
                    onClick={() => {
                      rejectconfirmation('1', row.restaurantId)
                    }}
                  >
                    {t('Approve')}
                  </button>
                  <button
                    className='btn btn-danger btn-sm me-3'
                    onClick={() => {
                      rejectconfirmation('2', row.restaurantId)
                    }}
                  >
                    {t('Reject')}
                  </button>
                </>
              ) : (
                '--'
              )}
            </div> : ""}
          </>
        ),
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? (
              <Link
                to={getEncryptedRoute('../../../addrestaurantbasicinfo/', { menuId: restaurantMenuId })}
                state={{ restaurantId: row.restaurantId, vendorId: row.vendorId }}
                className='btn btn-sm btn-icon btn-color-success btn-active-light-success'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTIcon iconName='notepad-edit' className='fs-2' />
              </Link>
            ) : (
              ''
            )}

            {menuIdDelete ? (
              <button
                onClick={() => confirmdelete(row.restaurantId)}
                className='btn btn-sm btn-icon btn-color-success btn-active-light-success'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTIcon iconName='trash-square' className='fs-2' />
              </button>
            ) : (
              ''
            )}
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Property Name')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end ' data-kt-user-table-toolbar='base'>
          {menuIdAdd ? <Link
            className='btn btn-success monthBtn text-white h-40px'
            id='kt_toolbar_primary_button'
            style={{ color: 'rgb(24, 28, 50)' }}
            to={getEncryptedRoute('../../../addrestaurantbasicinfo/', { menuId: restaurantMenuId })}
          >
            + {t('Add Restaurant')}
          </Link> : ""}
        </div>
      </div>
    )
  }
  return (
    <>
      {orgRestaurntantList.length != 0 ? (
        <div className='d-flex flex-stack flex-wrap pt-10'>
          <>
            <DataTable
              columns={column}
              data={restaurantList}
              // progressPending={isLoading}
              pagination
              paginationServer={false}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} customSearch={hotelSearch} />
              }
              paginationComponentOptions={{
                rowsPerPageText: t('Rows Per Page'),
              }}
            />
          </>
        </div>
      ) : (
        <>
          <div className='text-center px-4'>
            <div className='d-flex justify-content-center align-items-center flex-column my-10'>
              <h2 className='fs-2x fw-bold mb-10'>{t('There Are No Property')}</h2>
            </div>
            <br />
          </div>
          <div className='d-flex justify-content-center'>
            <img
              className='mw-100 mh-300px'
              alt=''
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
            />
          </div>
        </>
      )}
    </>
  )
}

export { CafeRestaurant }
